const LOCATION_CHANGE = '@@router/LOCATION_CHANGE'; // hardcoded to save 9KB lib link just to get one value

const showPopupType = "SHOW_POPUP";
const hidePopupType = "HIDE_POPUP";

const showPopup = (popupType, popupProps) => dispatch => {
  dispatch({
    type: showPopupType,
    popupProps,
    popupType
  });
}
  
const hidePopup = () => dispatch => {
  dispatch({
    type: hidePopupType
  });
}

export const popupActions = {
    showPopup,
    hidePopup
};

const initialState = {
  popupType: null,
  popupProps: {}
}

// store reducer
export const reducer = (state, action) => {
  state = state || initialState;
  switch(action.type){
      case LOCATION_CHANGE:
          return initialState;
      case showPopupType:
          return { popupProps: action.popupProps, popupType: action.popupType, type: action.type };
      case hidePopupType:
        return initialState;
      default:
          return state;
  }
}